import { Link } from 'react-router-dom';

const LoginButton = () => {
  return (
    <Link  to="/login">Login</Link>
  );
};

export default LoginButton;
